import { SelectCheckboxs } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

const StudentsSelect = ({ options, value, label, t, onChange, labelKey, valueKey, shouldDebounce }) => {
  return (
    <div>
      <SelectCheckboxs
        buttonAllText={t('All students')}
        hasAvatar={true}
        label={label}
        labelKey={labelKey}
        onChange={onChange}
        options={options}
        selectAllText={t('All students')}
        shouldDebounce={shouldDebounce}
        value={value}
        valueKey={valueKey}
      />
    </div>
  );
};

StudentsSelect.propTypes = {
  labelKey: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  shouldDebounce: PropTypes.bool,
  t: PropTypes.func,
  value: PropTypes.array,
  valueKey: PropTypes.string,
  label: PropTypes.string,
};

StudentsSelect.defaultProps = {
  options: [],
  value: [],
  label: '',
  labelKey: 'name',
  valueKey: 'person_guid',
  shouldDebounce: true,
};

export default withTranslation(['common', 'placeholder'])(StudentsSelect);
